import "./webapp.0545c934.js";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49ed"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49ed"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("11S0m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f61bd5989dcb282$export$2e2bcd8739ae039; });

var $kqCb6 = parcelRequire("kqCb6");

var $kyF38 = parcelRequire("kyF38");
var $6f61bd5989dcb282$export$2e2bcd8739ae039 = (0, $kyF38.init)((0, $kqCb6.default).init());

});
parcelRegister("kqCb6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68953a7b0cf7e87e$export$2e2bcd8739ae039; });

var $4OodJ = parcelRequire("4OodJ");
class $68953a7b0cf7e87e$export$2e2bcd8739ae039 {
    static init() {
        return new $68953a7b0cf7e87e$export$2e2bcd8739ae039();
    }
    constructor(){
        this.LIST_KEY = 'accountsList';
        this.INDEX_KEY = 'accountsCurrentIndex';
        this.listFallback = [];
        this.currentIndexFallback = -1;
        this.useListFallback = false;
        this.useCurrentIndexFallback = false;
        try {
            const parsedJSON = JSON.parse(localStorage.getItem(this.LIST_KEY)) || [];
            this.listFallback = Array.isArray(parsedJSON) ? parsedJSON.map((0, $4OodJ.makeAccount)) : [];
        } catch  {
            this.listFallback = [];
        }
        const parsedIndex = Number(localStorage.getItem(this.INDEX_KEY));
        if (!Number.isNaN(parsedIndex)) this.currentIndexFallback = parsedIndex;
        try {
            if (!localStorage.getItem(this.LIST_KEY)) localStorage.setItem(this.LIST_KEY, JSON.stringify(this.listFallback));
        } catch  {
            this.useListFallback = true;
        }
        try {
            if (!localStorage.getItem(this.INDEX_KEY)) localStorage.setItem(this.INDEX_KEY, String(this.currentIndexFallback));
        } catch  {
            this.useCurrentIndexFallback = true;
        }
    }
    getCurrentIndex() {
        if (this.useCurrentIndexFallback) return this.currentIndexFallback;
        const parsedIndex = Number(localStorage.getItem(this.INDEX_KEY));
        if (Number.isNaN(parsedIndex)) return this.currentIndexFallback;
        this.currentIndexFallback = parsedIndex;
        return parsedIndex;
    }
    setCurrentIndex(index) {
        this.currentIndexFallback = index;
        try {
            localStorage.setItem(this.INDEX_KEY, String(index));
            this.useCurrentIndexFallback = false;
        } catch  {
            this.useCurrentIndexFallback = true;
        }
    }
    getList() {
        if (this.useListFallback) return this.listFallback;
        try {
            const storedList = localStorage.getItem(this.LIST_KEY);
            if (storedList === null) return this.listFallback;
            const parsedJSON = JSON.parse(storedList) || [];
            this.listFallback = Array.isArray(parsedJSON) ? parsedJSON.map((0, $4OodJ.makeAccount)) : [];
            return this.listFallback;
        } catch  {
            return this.listFallback;
        }
    }
    setList(list) {
        this.listFallback = list.map((account)=>(0, $4OodJ.makeAccount)({
                ...account,
                email: account.email || ''
            }));
        try {
            localStorage.setItem(this.LIST_KEY, JSON.stringify(this.listFallback));
            this.useListFallback = false;
        } catch  {
            this.useListFallback = true;
        }
    }
}

});
parcelRegister("4OodJ", function(module, exports) {

$parcel$export(module.exports, "makeAccount", function () { return $90da0b922ad371f6$export$11be4f79df749898; });
$parcel$export(module.exports, "calculateExpiredDate", function () { return $90da0b922ad371f6$export$6c5f1943c09e93a1; });

var $eQ75S = parcelRequire("eQ75S");
const $90da0b922ad371f6$export$11be4f79df749898 = ({ attendeeUid: attendeeUid, eventCode: eventCode, eventLogo: eventLogo = '', name: name = '', email: email = '', phoneNumber: phoneNumber = '', regDate: regDate, expiredDate: expiredDate = null })=>({
        attendeeUid: attendeeUid,
        eventCode: eventCode,
        eventLogo: eventLogo,
        name: name,
        email: email,
        phoneNumber: phoneNumber,
        regDate: new Date(regDate),
        expiredDate: expiredDate ? new Date(expiredDate) : null
    });
const $90da0b922ad371f6$export$6c5f1943c09e93a1 = (event, attendee)=>event.photo_auto_delete_days ? (0, $eQ75S.addDays)(attendee.created_date, event.photo_auto_delete_days) : null;

});
parcelRegister("eQ75S", function(module, exports) {

$parcel$export(module.exports, "addDays", function () { return $835d1d9e78c794a9$export$dd412b56f1e4d8aa; });
$parcel$export(module.exports, "formatDate", function () { return $835d1d9e78c794a9$export$3ae94a2503e890a1; });
function $835d1d9e78c794a9$export$dd412b56f1e4d8aa(targetDate, days) {
    const date = new Date(targetDate);
    date.setDate(date.getDate() + days);
    return date;
}
function $835d1d9e78c794a9$export$3ae94a2503e890a1(date, userLocale = navigator.language) {
    const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    };
    return new Intl.DateTimeFormat(userLocale, options).format(date);
}

});



parcelRegister("kyF38", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $7914cf1a7c28278d$export$2cd8252107eb640b; });

var $4OodJ = parcelRequire("4OodJ");
function $7914cf1a7c28278d$export$2cd8252107eb640b(storage) {
    const subscriptionsOnChangeCurrentIndex = [];
    return {
        addAccount: addAccount,
        updateAccount: updateAccount,
        isExistsAccount: isExistsAccount,
        findIndex: findIndex,
        findIndexByEventCode: findIndexByEventCode,
        getList: getList,
        setCurrentAccount: setCurrentAccount,
        getCurrentAccount: getCurrentAccount,
        getCurrentIndex: getCurrentIndex,
        onChangeCurrentIndex: onChangeCurrentIndex,
        setList: setList
    };
    function addAccount(params) {
        const account = (0, $4OodJ.makeAccount)(params);
        storage.setList([
            account,
            ...getList()
        ]);
    }
    function updateAccount(account) {
        const list = [
            ...getList()
        ];
        const index = list.findIndex((acc)=>acc.attendeeUid === account.attendeeUid && acc.eventCode === account.eventCode);
        if (index > -1) {
            const currentAccount = list[index];
            const updatedAccount = {
                ...currentAccount,
                ...account
            };
            list[index] = updatedAccount;
            storage.setList(list);
        }
    }
    function getCurrentAccount() {
        return getList()[storage.getCurrentIndex()] || null;
    }
    function getCurrentIndex() {
        return storage.getCurrentIndex();
    }
    function setCurrentAccount(index) {
        storage.setCurrentIndex(index);
        subscriptionsOnChangeCurrentIndex.forEach((callback)=>callback(index));
    }
    function onChangeCurrentIndex(callback) {
        subscriptionsOnChangeCurrentIndex.push(callback);
    }
    function getList() {
        return storage.getList();
    }
    function setList(list) {
        storage.setList(list);
    }
    function findIndex({ attendeeUid: attendeeUid, eventCode: eventCode }) {
        return getList().findIndex((account)=>account.attendeeUid === attendeeUid && account.eventCode === eventCode);
    }
    function findIndexByEventCode(eventCode) {
        return getList().findIndex((account)=>account.eventCode === eventCode);
    }
    function isExistsAccount({ attendeeUid: attendeeUid, eventCode: eventCode }) {
        return findIndex({
            attendeeUid: attendeeUid,
            eventCode: eventCode
        }) > -1;
    }
}

});



var $hMTg2 = parcelRequire("hMTg2");

var $8xm5I = parcelRequire("8xm5I");

var $8e45s = parcelRequire("8e45s");

var $5G16Z = parcelRequire("5G16Z");

var $iDUOs = parcelRequire("iDUOs");

var $3CHfY = parcelRequire("3CHfY");

var $cbWrn = parcelRequire("cbWrn");

var $5E6Ai = parcelRequire("5E6Ai");

var $5fFKb = parcelRequire("5fFKb");

var $11S0m = parcelRequire("11S0m");

var $6wMuu = parcelRequire("6wMuu");
const $1c4bdc54ad1c7ce7$var$modeSwitcher = (0, $5G16Z.initModeSwitcher)();
const $1c4bdc54ad1c7ce7$var$selectImage = (0, $iDUOs.initSelect)();
const $1c4bdc54ad1c7ce7$var$galleryVC = (0, $3CHfY.initGalleryViewController)({
    isShowDownloadBtn: false,
    isShowFavoriteBtn: false
});
const $1c4bdc54ad1c7ce7$var$actionPanel = (0, $cbWrn.initActionPanel)();
const $1c4bdc54ad1c7ce7$var$selectedPanel = (0, $5E6Ai.initSelectedPanel)();
const $1c4bdc54ad1c7ce7$var$emptyContent = $1c4bdc54ad1c7ce7$var$initEmptyContent();
const $1c4bdc54ad1c7ce7$var$addSelfieBtn = $1c4bdc54ad1c7ce7$var$initAddSelfieButton();
(async function init() {
    (0, $8xm5I.showLoading)();
    await (0, $6wMuu.initLoc)();
    (0, $6wMuu.setTextToElement)('.top-panel__menu-text', (0, $6wMuu.t)('title-registered-selfies'));
    $1c4bdc54ad1c7ce7$var$selectedPanel.updateAmountOfSelect(0);
    (0, $hMTg2.findSelfiesByAttendeeId)((0, $11S0m.default).getCurrentAccount().attendeeUid).then(({ result: selfies })=>{
        if (selfies.length === 0) $1c4bdc54ad1c7ce7$var$emptyContent.show();
        else {
            $1c4bdc54ad1c7ce7$var$emptyContent.hide();
            if (selfies.length < 5) $1c4bdc54ad1c7ce7$var$addSelfieBtn.show();
            $1c4bdc54ad1c7ce7$var$initGallery(selfies);
        }
        $1c4bdc54ad1c7ce7$var$initAddSelfies();
        (0, $8xm5I.hideLoading)();
    });
})();
function $1c4bdc54ad1c7ce7$var$initEmptyContent() {
    const $elem = document.querySelector('.empty-content');
    return {
        show: show,
        hide: hide
    };
    function show() {
        $elem.style.display = 'flex';
    }
    function hide() {
        $elem.style.display = 'none';
    }
}
function $1c4bdc54ad1c7ce7$var$initAddSelfieButton() {
    const $elem = document.querySelector('.float-button');
    return {
        show: show,
        hide: hide
    };
    function show() {
        $elem.style.display = 'inline-flex';
    }
    function hide() {
        $elem.style.display = 'none';
    }
}
function $1c4bdc54ad1c7ce7$var$initGallery(selfies) {
    $1c4bdc54ad1c7ce7$var$galleryVC.render(selfies.map($5fFKb.viewModel));
    $1c4bdc54ad1c7ce7$var$actionPanel.render([
        {
            id: 'delete',
            iconName: 'delete',
            text: (0, $6wMuu.t)('delete-btn')
        }
    ]);
    if ((0, $8xm5I.isMobile)()) {
        $1c4bdc54ad1c7ce7$var$modeSwitcher.switchToDefaultMode();
        $1c4bdc54ad1c7ce7$var$galleryVC.onClick(({ id: id })=>{
            if ($1c4bdc54ad1c7ce7$var$modeSwitcher.isSelectMode()) $1c4bdc54ad1c7ce7$var$selectImage.toggle(id);
        });
        $1c4bdc54ad1c7ce7$var$galleryVC.onLongTouch(({ id: id })=>{
            if ($1c4bdc54ad1c7ce7$var$modeSwitcher.isDefaultMode()) {
                $1c4bdc54ad1c7ce7$var$modeSwitcher.switchToSelect();
                $1c4bdc54ad1c7ce7$var$selectImage.select(id);
            }
        });
        $1c4bdc54ad1c7ce7$var$modeSwitcher.onSelectMode($1c4bdc54ad1c7ce7$var$galleryVC.enableSelect);
        $1c4bdc54ad1c7ce7$var$modeSwitcher.onSelectMode($1c4bdc54ad1c7ce7$var$actionPanel.show);
        $1c4bdc54ad1c7ce7$var$modeSwitcher.onSelectMode($1c4bdc54ad1c7ce7$var$selectedPanel.show);
        $1c4bdc54ad1c7ce7$var$modeSwitcher.onDefaultMode($1c4bdc54ad1c7ce7$var$galleryVC.disableSelect);
        $1c4bdc54ad1c7ce7$var$modeSwitcher.onDefaultMode($1c4bdc54ad1c7ce7$var$actionPanel.hide);
        $1c4bdc54ad1c7ce7$var$modeSwitcher.onDefaultMode($1c4bdc54ad1c7ce7$var$selectedPanel.hide);
        $1c4bdc54ad1c7ce7$var$selectImage.onUpdate((photos)=>{
            if (photos.size === 0) $1c4bdc54ad1c7ce7$var$modeSwitcher.switchToDefaultMode();
        });
    } else {
        $1c4bdc54ad1c7ce7$var$galleryVC.enableSelect();
        $1c4bdc54ad1c7ce7$var$galleryVC.onClick(({ id: id })=>$1c4bdc54ad1c7ce7$var$selectImage.toggle(id));
        $1c4bdc54ad1c7ce7$var$selectImage.onUpdate((photos)=>{
            if (photos.size === 0) {
                $1c4bdc54ad1c7ce7$var$actionPanel.hide();
                $1c4bdc54ad1c7ce7$var$selectedPanel.hide();
            } else {
                $1c4bdc54ad1c7ce7$var$actionPanel.show();
                $1c4bdc54ad1c7ce7$var$selectedPanel.show();
            }
        });
    }
    $1c4bdc54ad1c7ce7$var$selectImage.onSelect($1c4bdc54ad1c7ce7$var$galleryVC.select);
    $1c4bdc54ad1c7ce7$var$selectImage.onUnselect($1c4bdc54ad1c7ce7$var$galleryVC.unselect);
    $1c4bdc54ad1c7ce7$var$selectImage.onUnselectAll($1c4bdc54ad1c7ce7$var$galleryVC.unselectAll);
    $1c4bdc54ad1c7ce7$var$selectImage.onUpdate((photos)=>{
        if (photos.size === 0) $1c4bdc54ad1c7ce7$var$actionPanel.disableBtn('delete');
        else $1c4bdc54ad1c7ce7$var$actionPanel.enableBtn('delete');
    });
    $1c4bdc54ad1c7ce7$var$selectImage.onUpdate((photos)=>{
        $1c4bdc54ad1c7ce7$var$selectedPanel.updateAmountOfSelect(photos.size);
    });
    $1c4bdc54ad1c7ce7$var$actionPanel.onClickBtn('delete', ()=>{
        if (!$1c4bdc54ad1c7ce7$var$actionPanel.isDisabledBtn('delete')) $1c4bdc54ad1c7ce7$var$removeSelfie(selfies).then(()=>window.location.reload());
    });
    $1c4bdc54ad1c7ce7$var$selectedPanel.onClickClearBtn($1c4bdc54ad1c7ce7$var$selectImage.unselectAll);
}
function $1c4bdc54ad1c7ce7$var$removeSelfie(selfies) {
    const attendeeId = (0, $11S0m.default).getCurrentAccount().attendeeUid;
    const selectedPhotoUid = selfies.filter($5fFKb.includesById($1c4bdc54ad1c7ce7$var$selectImage.array())).map((photo)=>photo.uid);
    return Promise.all(selectedPhotoUid.map((photoUId)=>(0, $hMTg2.deleteSelfie)(attendeeId, photoUId)));
}
function $1c4bdc54ad1c7ce7$var$initAddSelfies() {
    const $triggerUploadPhoto = document.querySelector('#selfies-uploader');
    const $elements = document.querySelectorAll('.emit-selfies-uploader');
    Array.from($elements).forEach(($element)=>{
        $element.addEventListener('click', ()=>{
            $triggerUploadPhoto.click();
        });
    });
    $triggerUploadPhoto.addEventListener('change', function() {
        (0, $8xm5I.showLoading)();
        Promise.all(Array.from(this.files).map((file)=>(0, $8e45s.uploadSelfieImage)(file))).then(()=>{
            window.location.reload();
        }).catch((e)=>{
            if ((0, $8e45s.isUnsupportedPictureFormatError)(e)) alert((0, $6wMuu.t)('home-upload-unsupported-format-message'));
            (0, $8xm5I.hideLoading)();
            console.error(e);
        });
    });
}


//# sourceMappingURL=selfies.d113b3ae.js.map
